<h2 mat-dialog-title>{{dialogTitle}}</h2>
<mat-dialog-content>
  <p>{{dialogText}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial><label translate>yes</label></button>
  <button mat-button mat-dialog-close><label translate>no</label></button>
</mat-dialog-actions>